import { render, staticRenderFns } from "./招投标项目详情_老版本.vue?vue&type=template&id=771c048e&scoped=true"
import script from "./招投标项目详情_老版本.vue?vue&type=script&lang=js"
export * from "./招投标项目详情_老版本.vue?vue&type=script&lang=js"
import style0 from "./招投标项目详情_老版本.vue?vue&type=style&index=0&id=771c048e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771c048e",
  null
  
)

export default component.exports